import { createContext, useContext } from "react";

/**
 * Контекст аутентификации, предоставляющий данные о текущем пользователе и его правах.
 *
 * @component
 * @example
 * // Использование в компонентах:
 * const { currentUser, hasRole } = useAuth();
 */
export const AuthContext = createContext();

/**
 * Хук для использования контекста аутентификации.
 *
 * @returns {Object} Объект с данными и методами аутентификации
 * @property {Object|null} currentUser - Текущий авторизованный пользователь или null
 * @property {Function} hasRole - Функция проверки наличия у пользователя определённой роли
 */
export const useAuth = () => {
    return useContext(AuthContext);
};